export enum MatrimonialRegime {
  SEPARATE_PROPERTY_WITH_EQUITABLE_DISTRIBUTION = 'COMUNHAO_PARCIAL',
  TENANCY_BY_THE_ENTIRETY = 'COMUNHAO_UNIVERSAL',
  SEPARATE_PROPERTY = 'SEPARACAO_TOTAL',
  ACCRUAL_SYSTEM = 'PARTICIPACAO_FINAL_AQUESTOS',
}
